export const BrandLogo = ({
  className = '',
  markClassName = '',
  textClassName = '',
  showWordmark = true,
  compact = false,
}) => {
  const sizeClass = compact ? 'w-9 h-9' : 'w-12 h-12';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${sizeClass} ${markClassName}`}>
        <svg viewBox="0 0 64 64" className="w-full h-full" role="img" aria-label="CricketHub logo">
          <defs>
            <linearGradient id="brandShield" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#15803D" />
              <stop offset="55%" stopColor="#16A34A" />
              <stop offset="100%" stopColor="#EAB308" />
            </linearGradient>
          </defs>
          <rect x="4" y="4" width="56" height="56" rx="16" fill="url(#brandShield)" />
          <rect x="19" y="18" width="4" height="24" rx="2" fill="#F8FAFC" />
          <rect x="30" y="14" width="4" height="28" rx="2" fill="#F8FAFC" />
          <rect x="41" y="18" width="4" height="24" rx="2" fill="#F8FAFC" />
          <rect x="17" y="16" width="30" height="4" rx="2" fill="#F8FAFC" />
          <path d="M20 47C24 44 28 42 32 42C36 42 40 44 44 47" stroke="#F8FAFC" strokeWidth="4" strokeLinecap="round" fill="none" />
          <circle cx="48" cy="23" r="7" fill="#B91C1C" />
          <path d="M44.5 19.5C46.8 20.8 49.2 25.2 51.5 26.5" stroke="#FCA5A5" strokeWidth="1.8" strokeLinecap="round" fill="none" />
          <path d="M45 26.2C47.1 24.6 48.9 21.4 51 19.8" stroke="#FCA5A5" strokeWidth="1.8" strokeLinecap="round" fill="none" />
        </svg>
      </div>

      {showWordmark && (
        <div className={textClassName}>
          <div className="font-bold tracking-tight leading-none text-lg">CricketHub</div>
          <div className="text-[11px] uppercase tracking-[0.28em] text-muted-foreground mt-1">Live Tournament Desk</div>
        </div>
      )}
    </div>
  );
};
